
<template>
  <div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <!---->
      <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <!-- Custom Tabs -->
            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a
                    href="#tab_current"
                    data-toggle="tab"
                  >{{$t('apartmentbookings.info_tab.current')}}</a>
                </li>
                <li>
                  <a
                    href="#tab_upcomming"
                    data-toggle="tab"
                  >{{$t('apartmentbookings.info_tab.upcomming')}}</a>
                </li>
                <li>
                  <a href="#tab_past" data-toggle="tab">{{$t('apartmentbookings.info_tab.past')}}</a>
                </li>
                <li>
                  <a href="#tab_history_all_booking" data-toggle="tab">{{$t('apartmentbookings.info_tab.all')}}</a>
                </li>
              </ul>

              <div class="tab-content">
                <div class="tab-pane active" id="tab_current">
                  <div class="row">
                    <div class="col-xs-12 table-responsive">
                      <b-table
                        :items="allBooking.current_bookings"
                        :fields="current_fields"
                        class="mt-3"
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="tab_upcomming">
                  <div class="row">
                    <div class="col-xs-12 table-responsive">
                      <b-table
                        :items="allBooking.upcomming_bookings"
                        :fields="current_fields"
                        class="mt-3"
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="tab_past">
                  <div class="row">
                    <div class="col-xs-12 table-responsive">
                      <b-table
                        :items="allBooking.past_bookings"
                        :fields="current_fields"
                        class="mt-3"
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="tab_history_all_booking">
                  <div class="row">
                    <div class="col-xs-12 table-responsive">
                      <b-table
                        :items="allBooking.all_booking"
                        :fields="current_fields"
                        class="mt-3"
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!---->
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import utils from "@/lib/utils";

export default {
  name: "ApartmentAdd",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      infoShow: false,
      apartmentStatusOptions: [
        { text: "Chưa Bàn Giao", value: 1 },
        { text: "Bàn Giao", value: 2 },
        { text: "Đã Ở", value: 3 }
      ],
      isExistTenant: false,
      pagetitle: "apartment.editaddnew[0]",
      allBooking: {
        current_bookings: [],
        upcomming_bookings: [],
        past_bookings: [],
        all_booking: []
      },
      current_fields: [
        {
          key: "booking_code",
          label: "apartment.reservations.reservation_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "apartment_code",
          label: "apartment.reservations.apartment_code",
          sortable: true,
          class: "text-center"
        },
        {
          key: "customer_name",
          label: "apartment.reservations.customer_name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "checkin_datetime",
          label: "apartment.reservations.date_checkin",
          sortable: true,
          class: "text-center"
        },
        {
          key: "checkout_datetime",
          label: "apartment.reservations.date_checkout",
          sortable: true,
          class: "text-center"
        }
      ],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      customer_name: "",
      identification_card: ""
    };
  },

  watch: {
    GET_ALL_BOOKING_BY_APARTMENT_DATA: function() {
      this.allBooking.current_bookings = [];
      this.allBooking.upcomming_bookings = [];
      this.allBooking.past_bookings = [];
      this.allBooking.all_booking = [];

      if(this.GET_ALL_BOOKING_BY_APARTMENT_DATA['all_bookings'].length > 0){

        this.GET_ALL_BOOKING_BY_APARTMENT_DATA['current_bookings'].forEach(
          booking => {
            let checkin_datetime = utils.formatSqlDate(booking.checkin_datetime, null, this.options.format);
            let checkout_datetime = utils.formatSqlDate(booking.checkout_datetime, null, this.options.format);
            let customer_name = booking.booking_person_name ? booking.booking_person_name : null
            /*let customer_name =
              booking.customer.last_name + " " + booking.customer.first_name;*/
            let current_bookings = {
              booking_code: booking.booking_code,
              apartment_code: booking.apartment_code,
              customer_name: customer_name,
              checkin_datetime: checkin_datetime,
              checkout_datetime: checkout_datetime
            };
            this.allBooking.current_bookings.push(current_bookings);
          }
        );

        this.GET_ALL_BOOKING_BY_APARTMENT_DATA['upcomming_bookings'].forEach(
          booking => {
            let checkin_datetime = utils.formatSqlDate(booking.checkin_datetime, null, this.options.format);
            let checkout_datetime = utils.formatSqlDate(booking.checkout_datetime, null, this.options.format);
            /*let customer_name =
              booking.customer.last_name + " " + booking.customer.first_name;*/
            let customer_name = booking.booking_person_name ? booking.booking_person_name : null
            let upcomming_bookings = {
              booking_code: booking.booking_code,
              apartment_code: booking.apartment_code,
              customer_name: customer_name,
              checkin_datetime: checkin_datetime,
              checkout_datetime: checkout_datetime
            };
            this.allBooking.upcomming_bookings.push(upcomming_bookings);
          }
        );
        this.GET_ALL_BOOKING_BY_APARTMENT_DATA['past_bookings'].forEach(booking => {
          let checkin_datetime = utils.formatSqlDate(booking.checkin_datetime, null, this.options.format);
          let checkout_datetime = utils.formatSqlDate(booking.checkout_datetime, null, this.options.format);
          /*let customer_name =
            booking.customer.last_name + " " + booking.customer.first_name;*/
          let customer_name = booking.booking_person_name ? booking.booking_person_name : null
          let past_bookings = {
            booking_code: booking.booking_code,
            apartment_code: booking.apartment_code,
            customer_name: customer_name,
            checkin_datetime: checkin_datetime,
            checkout_datetime: checkout_datetime
          };
          this.allBooking.past_bookings.push(past_bookings);
        });

        this.GET_ALL_BOOKING_BY_APARTMENT_DATA['all_bookings'].forEach(booking => {
          let checkin_datetime = utils.formatSqlDate(booking.checkin_datetime,  null, this.options.format);
          let checkout_datetime = utils.formatSqlDate(booking.checkout_datetime,  null, this.options.format);
          /*let customer_name =
            booking.customer.last_name + " " + booking.customer.first_name;*/
          let customer_name = booking.booking_person_name ? booking.booking_person_name : null
          let all_bookings = {
            booking_code: booking.booking_code,
            apartment_code: booking.apartment_code,
            customer_name: customer_name,
            checkin_datetime: checkin_datetime,
            checkout_datetime: checkout_datetime
          };
          this.allBooking.all_booking.push(all_bookings);
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ALL_BOOKING_BY_APARTMENT_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_ALL_BOOKING_BY_APARTMENT"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    }
  },
  mounted() {
    let id = this.item !== undefined ? this.item.id : this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.pagetitle = "apartment.editaddnew[1]";
      this.infoShow = true;
      const data_monthly = {
        params: {
          page: 1,
          apartmentid: id
        }
      };
      this.GET_ALL_BOOKING_BY_APARTMENT(data_monthly);
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackTenantBooking.vue